module.exports = __webpack_public_path__ + "img/symbol_10.5df85135.png";